import React from 'react';
import {
  Button,
  Card,
  CardClose,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@ais-ui/ui-core';
import { cn } from '@ais-ui/utils';
import { useLocalization } from '@ais-ui/locale-management';
import { useOnMapPanelExit } from '../Map/MapPanel/useOnMapPanelExit';
import { CreateReportProvider } from './Mutations/CreateReportTemplate/CreateReportContext';
import { CreateReportTemplate } from './Mutations/CreateReportTemplate/CreateReportTemplate';
import { ReportListContent } from './ReportListContent';

interface ReportListProps {
  className: string;
}

export const ReportList = ({ className }: ReportListProps) => {
  const { messages } = useLocalization();
  const onExit = useOnMapPanelExit();

  return (
    <Card className={cn('flex flex-col', className)}>
      <CardHeader variant="tinted">
        <CardClose onClick={() => onExit()} />
        <div className="space-y-2">
          <CardTitle className="text-lg font-medium text-muted-foreground">
            {messages.reportsListTitle}
          </CardTitle>
          <CardDescription>{messages.reportsListSubtitle}</CardDescription>
        </div>
      </CardHeader>
      <ReportListContent />
      <CardFooter className="flex flex-grow-0 flex-col items-end">
        <CreateReportProvider>
          <CreateReportTemplate>
            <Button id="reports-create-button">Create</Button>
          </CreateReportTemplate>
        </CreateReportProvider>
      </CardFooter>
    </Card>
  );
};
